import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=66f63f41&scoped=true&"
import script from "./SnackBar.vue?vue&type=script&lang=ts&"
export * from "./SnackBar.vue?vue&type=script&lang=ts&"
import style0 from "./SnackBar.vue?vue&type=style&index=0&id=66f63f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f63f41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
